import React from "react";
import { ReservaTransporte as ReservaTransporteG } from "../../../services/agendamientosGuarderiaServicios";
import { ReservaTransporte } from "../../../services/agendamientosHotelServicios";
import { InfoRow } from "./InfoRow";
import { ListaFechas } from "./ListaFechas";

export const DatosTransporte = ({
  reservaTransporte,
}: {
  reservaTransporte: ReservaTransporte | ReservaTransporteG;
}) => {
  const fechasProgramadas = reservaTransporte.fechasProgramadas;
  return (
    <>
      <div className="mb-2">
        <label className="mb-2" style={{ fontWeight: 500 }}>
          Fechas de transporte:
        </label>
        <ListaFechas fechas={fechasProgramadas} />
      </div>
      <InfoRow label="Sector de transporte" value={reservaTransporte.sector} />
      <InfoRow
        label="Dirección de transporte"
        value={reservaTransporte.direccion}
      />
    </>
  );
};
